const ITEMS = [
  "Ekspansja sieci",
  "Pozyskiwanie gruntów",
  "Analiza potencjału",
  "Prowadzenie inwestycji",
  "Samorząd & Biznes",
  "Polska Południowo-Wschodnia",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-[#1b2233] bg-[#090D16] py-5"
  >
    <div className="animate-marquee flex w-max items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-serif text-base uppercase tracking-[0.28em] text-[#c9a876]/85 sm:text-lg">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#c9a876]/40" />
        </span>
      ))}
    </div>
  </div>
);
